const state = {
  status: 'loading',
  error: null,
  order: [],
  orderDetails: {}
};

export default state;
